
import { Divider, Form, Input, Spin, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { shouldComponentBeVisible } from '../../utils/evaluateCondition';
import globalGetPadding from '../../utils/getPadding';
import { getDynamicFieldByCode } from '../../../../api/customForm';
import { getMerchantCode, getMerchantCode2, shallowEqualIgnoreOrder } from '../../utils/commonFun';
import { getBorderRadiusValue } from '../../utils/borderRadius';
function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

const DynamicPropsDefaults = {
    label: '',
    name: '',
    placeholder: '',
    options: [],
    multiple: false,
    required: false,
    visible: {
        alwaysShow: true,
        conditions: []
    },
    isFormItem: true,
    disabled: false
};


const StyledSelect = styled(Select)`
    & {
        display: block !important;
        width: ${({$inputWidth})=>$inputWidth ? $inputWidth+' !important' : '100% !important'};
        max-width: 100% !important;
        min-width: 0 !important;
        overflow: hidden !important;
        box-sizing: border-box !important;
    }
    .ant-select-selector {
        width: ${({$inputWidth})=>($inputWidth+' !important')};
        border-radius: ${({$inputBorderRadius})=> {
            const value = getBorderRadiusValue($inputBorderRadius);
            return value ? `${value} !important` : '';
        }};
        font-size: ${({$inputFontSize})=>($inputFontSize ? $inputFontSize+'px !important' : '')};
        color: ${({$inputColor})=>($inputColor ? $inputColor+' !important' : '')};
        background-color: ${({$inputBackgroundColor})=>($inputBackgroundColor ? $inputBackgroundColor+' !important' : '')};
        border-color: ${({$inputBorderColor})=>($inputBorderColor ? $inputBorderColor+' !important' : '')};
        border-width: ${({$inputBorderWidth})=>($inputBorderWidth ? $inputBorderWidth+'px !important' : '')};
        padding: ${({$inputPadding})=>($inputPadding ? $inputPadding+' !important' : '')};
        
        overflow: hidden;
    }
    .ant-select-selection-item,
    .ant-select-selection-placeholder,
    .ant-select-selection-search-input {
        font-size: ${({$inputFontSize})=>$inputFontSize ? `${$inputFontSize}px !important` : 'inherit !important'};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 100%;
    }
    .ant-select-selection-wrap {
        min-width: 0;
        overflow: hidden;
    }
    .ant-select-selection-search {
        min-width: 0;
        max-width: 100%;
        overflow: hidden;
    }
`;

export const FormDynamic = (_a)=> {
    const rootData = _a.form_data.root;
    const root_formStyle = rootData?.data?.formStyle;
    const root_formMessage = rootData?.data?.messageData;
    const isMobile = _a.formClientWidth <= 480;
    var _b, _c, _d, _e, _f;
    var style = _a.style;
    var wStyle = {
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
        borderRadius: getBorderRadiusValue((_f = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _f !== void 0 ? _f : undefined),
    };
    var labelStyle = {
        color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined,
        fontSize: (_d = style === null || style === void 0 ? void 0 : style?.fontSize) !== null && _d !== void 0 ? (isMobile ? _d/1.1 : _d) : undefined,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
    }
    var  _n, _o, _p, _q, _r, _s;
    var inputStyle = {
        width: '100%',
        borderRadius: getBorderRadiusValue((_s = style === null || style === void 0 ? void 0 : style.inputBorderRadius) !== null && _s !== void 0 ? _s : undefined),
        fontSize: (_n = style === null || style === void 0 ? void 0 : style?.inputFontSize) !== null && _n !== void 0 ? (isMobile ? _n/1.1 : _n) : undefined,
        color: (_o = style === null || style === void 0 ? void 0 : style.inputColor) !== null && _o !== void 0 ? _o : undefined,
        backgroundColor: (_p = style === null || style === void 0 ? void 0 : style.inputBackgroundColor) !== null && _p !== void 0 ? _p : undefined,
        borderColor: (_q = style === null || style === void 0 ? void 0 : style.inputBorderColor) !== null && _q !== void 0 ? _q : undefined,
        borderWidth: (_r = style === null || style === void 0 ? void 0 : style.inputBorderWidth) !== null && _r !== void 0 ? _r : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.inputPadding, isMobile),
    }
    // var text = (_g = props === null || props === void 0 ? void 0 : props.text) !== null && _g !== void 0 ? _g : TextPropsDefaults.text;
    // return <div style={wStyle}>
    //     {text}
    // </div>;

    var _g, _h, _i, _j, _k, _l, _m, _t, _u;
    var props = _a.props;
    var label = (_g = props === null || props === void 0 ? void 0 : props.label) !== null && _g !== void 0 ? _g : DynamicPropsDefaults.label;
    var name = (_h = props === null || props === void 0 ? void 0 : props.name) !== null && _h !== void 0 ? _h : DynamicPropsDefaults.name;
    var placeholder = (_i = props === null || props === void 0 ? void 0 : props.placeholder) !== null && _i !== void 0 ? _i : DynamicPropsDefaults.placeholder;
    var options = (_j = props === null || props === void 0 ? void 0 : props.options) !== null && _j !== void 0 ? _j : DynamicPropsDefaults.options;
    var required = (_k = props === null || props === void 0 ? void 0 : props.required) !== null && _k !== void 0 ? _k : DynamicPropsDefaults.required;
    var visible = (_l = props === null || props === void 0 ? void 0 : props.visible) !== null && _l !== void 0 ? _l : DynamicPropsDefaults.visible;
    var multiple = (_m = props === null || props === void 0 ? void 0 : props.multiple) !== null && _m !== void 0 ? _m : DynamicPropsDefaults.multiple;
    var canSearch = (_t = props === null || props === void 0 ? void 0 : props.canSearch) !== null && _t !== void 0 ? _t : DynamicPropsDefaults.canSearch;
    var disabled = (_u = props === null || props === void 0 ? void 0 : props.disabled) !== null && _u !== void 0 ? _u : DynamicPropsDefaults.disabled;

    const formStyle = _a.formStyle;
    const item_layout = !formStyle?.layout && root_formStyle?.layout ? root_formStyle?.layout : formStyle?.layout ? 
        formStyle?.layout : '';
    const item_colon = formStyle?.colon === undefined && root_formStyle?.colon !== undefined ? root_formStyle?.colon : formStyle?.colon

    const requiredText = props?.requiredText !== null && props?.requiredText !== void 0 ? props?.requiredText : root_formMessage?.required;
    
    const [searchValue, setSearchValue] = useState('');
    const [fieldHidden, setFieldHidden] = useState(false);
    const [fieldLoading, setFieldLoading] = useState(false);
    const [lastDependFields, setLastDependFields] = useState({});
    const [dependFields, setDependFields] = useState({});
    const [dynamicFields, setDynamicFields] = useState([]);

    const handleOnchange = useCallback((val, code)=>{
        setSearchValue('');
        _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
            ...prevData,
            [code]: {
                value: val,
                isRequired: prevData[name]?.isRequired,
                type: prevData[name]?.type
            }
        }))
    }, [_a, name]);

    useEffect(()=>{
        const fetchData = async () => {
            let res = [];
            if(_a?.fieldSource?.type === 'api' && _a?.fCode) {
                //如果options是通过api获取，走这里�?
                if(!fieldLoading) {
                    let dependValues = {};
                    let fullField = true;
                    if(_a?.fieldSource?.depends?.length) {
                        //需要获取其他字段的值来决定options，才发请�?
                        _a?.fieldSource?.depends?.forEach(item=>{
                            if(!dependFields[item.fromField]) {
                                fullField = false;
                            }
                            else if((dependFields[item.fromField]?.isRequired && dependFields[item.fromField]?.value) || !dependFields[item.fromField]?.isRequired) {
                                dependValues[item.targetParam] = dependFields[item.fromField]?.value;
                            }
                            else {
                                fullField = false;
                            }
                        })
                    }
                    if(fullField) {
                        setFieldLoading(true);
                        const merchantCode = getMerchantCode(_a?.cmCode, 'form');
                        const getRes = await getDynamicFieldByCode({
                            "formCode": _a?.fCode,
                            "fieldCode": name,
                            "dependValues": dependValues
                        }, merchantCode || getMerchantCode2(_a?.cmCode), merchantCode ? null : 'form').catch(error => {
                            return null; // 必须 return，否�?getRes �?undefined
                        });
                        setFieldLoading(false);
                        if(getRes?.fields) {
                            setDynamicFields(getRes?.fields)
                        }
                    }
                }
            }
        };
        
        fetchData();
    }, [_a?.fieldSource?.type, _a?.fCode,
        _a?.fieldSource?.type === 'api' ? (_a?.fieldSource?.depends?.length ? dependFields : null) : _a?.allFieldValues
    ])

    const calVisible = useMemo(()=>{
        if(visible?.alwaysShow) {
            return true;
        }
        else {
            return shouldComponentBeVisible(visible?.conditions, _a?.allFieldValues);
        }
    }, [visible, _a?.allFieldValues])

    useEffect(()=>{
        if(!calVisible && _a?.formRef && !_a?.props?.hiddenOnly) {
            _a?.formRef.setFieldValue(name, undefined);
            _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                ...prevData,
                [name]: {
                    value: undefined,
                    isRequired: prevData[name]?.isRequired,
                    type: prevData[name]?.type
                }
            }))
        }
    }, [calVisible])

    useEffect(()=>{
        if(!_a.allFieldValues) return;
        dynamicFields.forEach(d_item=>{
            const d_field = _a.allFieldValues[name+"_dynamic_"+d_item.code];
            if(d_field) {
                const currentValue = d_field?.value;
                if(!d_item.options.find(item=>Array.isArray(currentValue) ? currentValue.includes(item.value) : currentValue === item.value) && _a?.formRef) {
                    //当前的值不属于options里面的，清空
                    _a?.formRef.setFieldValue(name+"_dynamic_"+d_item.code, undefined);
                    _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                        ...prevData,
                        [name+"_dynamic_"+d_item.code]: {
                            value: undefined,
                            isRequired: prevData[name]?.isRequired,
                            type: prevData[name]?.type
                        }
                    }))
                }
            }
        })
    }, [dynamicFields])

    
        
    useEffect(()=>{
        //fieldSource: 通过api获取当前组件的数据，比如option
        if(_a?.fieldSource?.type === 'api' && _a?.fieldSource?.depends?.length) {
            let depend_fields = {};
            _a?.fieldSource?.depends?.forEach(item=>{
                depend_fields[item.fromField] = _a?.allFieldValues[item.fromField];
            })
            if (!shallowEqualIgnoreOrder(lastDependFields, depend_fields)) {
                setDependFields(depend_fields);
                setLastDependFields(depend_fields);
            }
        }
    }, [_a?.fieldSource, _a?.allFieldValues])

    useEffect(()=>{
        //otherCustom: 后端传的其他数据，其中有displayOnly，hidden等字段，控制组件的隐藏和只读。hidden时组件渲染但是不显示�?
        if(_a?.props?.hiddenOnly === true) {
            setFieldHidden(true);
        }
        else {
            setFieldHidden(false);
        }
    }, [_a?.props?.hiddenOnly])

    return (!calVisible && !fieldHidden) || !dynamicFields?.length ? null : 
    dynamicFields?.map(d_item=>{
        return  <Spin spinning={fieldLoading}><div style={{...wStyle, ...fieldHidden ? {
            visibility: 'hidden',
            opacity: 0,
            height: 0,
            overflow: 'hidden',
            padding: 0,
            margin: 0,
            border: 0
        } : {}}}>
            <Form.Item
                label={d_item.label && d_item.label.trim() ? <span style={labelStyle}>{item_layout === 'vertical' && item_colon ? d_item.label+": " : d_item.label}</span> : undefined}
                name={name+"_dynamic_"+d_item.code}
                className={(!formStyle?.labelAlign && root_formStyle?.labelAlign === 'right') || formStyle?.labelAlign === 'right' ? 
                    'ant-form-item-label-right' : ''}
                layout={item_layout}
                colon={item_colon}
                rules={required ? [{ required: true, message: requiredText}] : []}
            >
                {
                    d_item.type === "dropdown" ? <StyledSelect
                        $inputWidth={inputStyle.width}
                        $inputBorderRadius={inputStyle.borderRadius}
                        $inputFontSize={inputStyle.fontSize}
                        $inputColor={inputStyle.color}
                        $inputBackgroundColor={inputStyle.backgroundColor}
                        $inputBorderColor={inputStyle.borderColor}
                        $inputBorderWidth={inputStyle.borderWidth}
                        $inputPadding={inputStyle.padding}
                        placeholder={placeholder}
                        options={canSearch && searchValue
                            ? d_item.options?.filter(all_sel =>
                                all_sel.label.toLowerCase().includes(searchValue.toLowerCase())
                            )
                            : d_item.options
                        }
                        disabled={disabled}
                        mode={multiple ? 'multiple' : null}
                        // showSearch
                        // optionFilterProp="label"
                        allowClear={true}
                        onChange={(val)=>{
                            handleOnchange(val, name+"_dynamic_"+d_item.code);
                        }}
                        dropdownRender={(menu)=>(canSearch ? <div>
                            <div style={{ padding: 8 }}>
                                <Input
                                    placeholder="Search..."
                                    value={searchValue}
                                    onChange={e => setSearchValue(e.target.value)}
                                    onKeyDown={e => e.stopPropagation()}
                                    suffix={<SearchOutlined />}
                                />
                            </div>
                            <Divider style={{ margin: '8px 0' }} />
                            {menu}
                        </div> : menu)}
                    /> : <Input
                        placeholder={placeholder} 
                        style={inputStyle}
                        allowClear={true}
                        disabled={disabled}
                        onChange={(e)=>{
                            handleOnchange(e.target.value, name+"_dynamic_"+d_item.code);
                        }}
                    />
                }
                
            </Form.Item>
        </div></Spin>;
    })
}




